<template>
  <div class="flex flex-col gap-4">
    <h3 class="text-t6">Får vi gå in med huvudnyckel eller vill du att vi ringer först?</h3>
    <Transition name="loader-fade" mode="out-in">
      <template v-if="getKeyOptions.length">
        <div class="flex flex-col gap-4">
          <RadioButton v-for="option in getKeyOptions"
            :id="option.value"
            :label="option.name"
            name="access"
            v-model="accessType"
            :value="option.value"
          />
        </div>
      </template>
      <LoaderErrorReport v-else />
    </Transition>
  </div>

  <div v-if="callBefore">
    <div class="grid grid-rows-1 md:grid-cols-2 gap-6">
      <div class="flex flex-col gap-2">
        <p class="text-b2">Ring mig på telefon:</p>
        <Input
          id="phoneNumber"
          label="Telefonnummer"
          type="tel"
          placeholder="Telefonnummer"
          :floatingLabel="true"
          v-model="phoneNumber"
        />
      </div>
      <div class="flex flex-col gap-2">
        <p class="text-b2">Jag nås enklast mellan:</p>
        <div class="flex flex-row gap-6">
          <SelectField
            id="from"
            label="Från"
            placeholder="Från"
            :floatingLabel="true"
            :options="callBetweenFromOptions"
            v-model="callBetween.from"
          />
          <SelectField
            id="to"
            label="Till"
            placeholder="Till"
            :floatingLabel="true"
            :options="callBetweenToOptions"
            v-model="callBetween.to"
          />
        </div>
      </div>
    </div>
    <div class="text-b2 mt-6 rounded-[15px] bg-primary-10 p-4">
      Obs! Vi kommer eventuellt ringa från dolt nummer. Det är viktigt att du svarar för att vi ska
      kunna utföra din felanmälan.
    </div>
  </div>
</template>
<script>
import RadioButton from '@/components/ui/form/radioAlt';
import SelectField from '@/components/ui/form/select';
import Input from '@/components/ui/form/input';
import { mapGetters } from 'vuex';
import LoaderErrorReport from '@/pages/create-error-report/routes/row-editor/loadererrorreport';

export default {
  name: 'Access',
  components: { LoaderErrorReport, RadioButton, Input, SelectField },

  props: {
    access: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      accessType: null,
      phone: null,
      phoneNumber: null,
      callBetween: { from: '07:00', to: '16:00' },
      callBefore: true,
    };
  },

  watch: {
    // --- Access type ---
    accessType: {
      immediate: true,
      handler(type) {
        if (!type) return;
        const option = this.getKeyOptions.find(o => o.value === type);
        this.callBefore = !!option?.callBefore;

        // Emit new access state
        this.emit();

        // Handle validation
        if (!type) {
          this.$emit('update:validation', false);
          return;
        }

        if (option?.masterKey) {
          this.$emit('update:validation', true);
        } else if (option?.callBefore) {
          this.$emit('update:validation', !!this.phoneNumber);
        }
      }
    },

    // --- Phone ---
    phone() {
      this.emit();

      if (this.accessType === 'outside') {
        this.$emit('update:validation', true);
      }
    },

    phoneNumber() {
      this.emit();
    },

    // --- Time range ---
    callBetween: {
      deep: true,
      handler() {
        this.emit();
      }
    }
  },

  computed: {
    ...mapGetters({
      getKeyOptions: 'getKeyOptions'
    }),

    callBetweenFromOptions() {
      const values = this.getTimes();
      return values.splice(0, values.findIndex(x => x.value === this.callBetween.to));
    },

    callBetweenToOptions() {
      const values = this.getTimes();
      return values.splice(values.findIndex(x => x.value === this.callBetween.from) + 1);
    }
  },

  methods: {
    // Time options
    getTimes() {
      return [
        { label: '07:00', value: '07:00' },
        { label: '07:30', value: '07:30' },
        { label: '08:00', value: '08:00' },
        { label: '08:30', value: '08:30' },
        { label: '09:00', value: '09:00' },
        { label: '09:30', value: '09:30' },
        { label: '10:00', value: '10:00' },
        { label: '10:30', value: '10:30' },
        { label: '11:00', value: '11:00' },
        { label: '11:30', value: '11:30' },
        { label: '12:00', value: '12:00' },
        { label: '12:30', value: '12:30' },
        { label: '13:00', value: '13:00' },
        { label: '13:30', value: '13:30' },
        { label: '14:00', value: '14:00' },
        { label: '14:30', value: '14:30' },
        { label: '15:00', value: '15:00' },
        { label: '15:30', value: '15:30' },
        { label: '16:00', value: '16:00' },
      ];
    },

    // Unified emit for v-model and draft
    emit() {
      this.$emit('update:access', {
        masterKey: this.accessType,
        phone: this.accessType === 'call' ? this.phone : null,
        phoneNumber: this.phoneNumber,
        callBetween: this.accessType === 'call' ? this.callBetween : null,
      });
    }
  },

  created() {
    this.$store.cache.dispatch('fetchKeyOptions');
    if (!!this.$store.getters.profile.defaultPhone) {
      let defaultPhone = this.$store.getters.profile.defaultPhone == "mobilePhone" ? 'phoneMobile' : this.$store.getters.profile.defaultPhone;
      this.phoneNumber = this.$store.getters.profile[defaultPhone] ? this.$store.getters.profile[defaultPhone].replace('-', '') : '';
    }

    // Init local state from parent-access
    this.accessType = this.access.masterKey ?? 'master';
    this.phone = this.access.phone ?? null;
    this.callBetween = this.access.callBetween || { from: '07:00', to: '16:00' };
  }
};
</script>
